export const options = ['Card Payment (Domestic ATM, Visa, MasterCard)', 'Cash on Delivery (COD)']
